<template>
    <div class="box account">
        <p class="title">アカウントについて</p>
        <div class="formWrap">
            <el-form
                ref="account"
                :rules="accountRules"
                :label-position="labelPosition"
                :model="accountForm"
                label-width="267px"
            >
                <el-form-item label="プレイヤー名" prop="name">
                    <el-input v-model="accountForm.name"></el-input>
                </el-form-item>
                <el-form-item label="プレイヤーID" prop="friendID">
                    <el-input v-model="accountForm.friendID"></el-input>
                    <span class="tip">※友人検索画面右上に表示</span>
                </el-form-item>
                <el-form-item label="メールアドレス" prop="email">
                    <el-input v-model="accountForm.email"></el-input>
                </el-form-item>
                <el-form-item class="required" label="メールアドレス（確認）" prop="reemail">
                    <el-input v-model="accountForm.reemail"></el-input>
                </el-form-item>
                <el-form-item label="段位" prop="rank">
                    <el-input v-model="accountForm.rank"></el-input>
                </el-form-item>
                <el-form-item class="inputsBox required" label="所持キャラクターと絆ポイント" prop="favorability">
                    <el-input v-model="accountForm.favorability.value1"></el-input>
                    <el-input v-model="accountForm.favorability.value2"></el-input>
                    <el-input v-model="accountForm.favorability.value3"></el-input>
                    <el-checkbox v-model="accountForm.favorability.novalue">不明</el-checkbox>
                </el-form-item>
                <el-form-item class="required" label="所持しているコイン" prop="gold">
                    <el-input v-model="accountForm.gold.value"></el-input>
                    <el-checkbox v-model="accountForm.gold.novalue">不明</el-checkbox>
                </el-form-item>
                <el-form-item class="required" label="所持している輝石" prop="stone">
                    <el-input v-model="accountForm.stone.value"></el-input>
                    <el-checkbox v-model="accountForm.stone.novalue">不明</el-checkbox>
                </el-form-item>
                <el-form-item label="ゲームを開始した日時" prop="createAccountTime">
                    <el-date-picker
                        v-model="accountForm.createAccountTime"
                        type="date"
                        value-format="timestamp"
                        placeholder="日付を選択"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item class="required" label="ゲーム内で設定した生年月" prop="birthday">
                    <el-date-picker
                        v-model="accountForm.birthday.value"
                        type="month"
                        value-format="timestamp"
                        placeholder="日付を選択"
                    ></el-date-picker>
                    <br>
                    <el-checkbox v-model="accountForm.birthday.novalue">未設定</el-checkbox>
                </el-form-item>
                <el-form-item label="購入記録" prop="buyHistory">
                    <el-upload
                        action="/"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-exceed="handleExceed"
                        :on-change="handleChange"
                        :auto-upload="false"
                        multiple
                        :limit="3"
                        :file-list="fileList"
                    >
                        <el-button size="small" type="primary">クリックしてアップロード</el-button>
                        <div slot="tip" class="el-upload__tip">
                            ※注文番号、日付、合計金額、購入アイテム、単価を確認できるように撮影をお願いいたします。
                            <br>※1週間以内に同アイテムで複数の履歴がある場合には、全てお送りください。
                            <br>※画像はひとつ4MB以内でお願いします。
                        </div>
                    </el-upload>
                    <el-checkbox v-model="accountForm.buyHistory.novalue">購入なし</el-checkbox>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 5}"
                        v-model="accountForm.content"
                    ></el-input>
                </el-form-item>
                <el-form-item class="required" label="個人情報の取り扱いについて" prop="perChecked">
                    <el-checkbox v-model="accountForm.perChecked">同意する</el-checkbox>
                    <a
                        class="checked"
                        target="_blank"
                        href="https://mahjongsoul.com/privacy_policy"
                    >※プライバシーポリシーをご確認ください。</a>
                </el-form-item>
                <el-form-item label>
                    <el-button size="medium" type="info" plain @click="accountConfirm">上記内容で送信</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: "account",
    data() {
        // 自定义表单验证规则
        const account_reemail = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("もう一度メールアドレスを入力してください"));
            } else if (value !== this.accountForm.email) {
                callback(new Error("メールアドレスが一致しません"));
            } else {
                callback();
            }
        };

        const account_favorability = (rule, value, callback) => {
            if (value.novalue) {
                callback();
            } else if (!value.value1 && !value.value2 && !value.value3) {
                callback(new Error("必須"));
            } else {
                callback();
            }
        };

        const account_gold = (rule, value, callback) => {
            if (value.novalue) {
                callback();
            } else if (!value.value) {
                callback(new Error("必須"));
            } else {
                callback();
            }
        };

        const account_stone = (rule, value, callback) => {
            if (value.novalue) {
                callback();
            } else if (!value.value) {
                callback(new Error("必須"));
            } else {
                callback();
            }
        };

        const account_birthday = (rule, value, callback) => {
            if (value.novalue) {
                callback();
            } else if (!value.value) {
                callback(new Error("必須"));
            } else {
                callback();
            }
        };

        const account_buyHistory = (rule, value, callback) => {
            if (value.novalue) {
                callback();
            } else if (!this.fileList.length) {
                callback(new Error("必須"));
            } else {
                callback();
            }
        };

        const account_perChecked = (rule, value, callback) => {
            if (!value) {
                callback(new Error("同意してください"));
            } else {
                callback();
            }
        };

        return {
            labelPosition: "right",
            fileList: [],
            accountForm: {
                name: "",
                friendID: "",
                email: "",
                reemail: "",
                rank: "",
                favorability: {
                    value1: "",
                    value2: "",
                    value3: "",
                    novalue: false
                },
                gold: {
                    value: "",
                    novalue: false
                },
                stone: {
                    value: "",
                    novalue: false
                },
                createAccountTime: "",
                birthday: {
                    value: "",
                    novalue: false
                },
                buyHistory: {
                    novalue: true
                },
                content: "",
                perChecked: false
            },
            accountRules: {
                name: [{ required: true, message: "必須", trigger: "blur" }],
                friendID: [
                    { required: true, message: "必須", trigger: "blur" }
                ],
                email: [
                    {
                        required: true,
                        message: "必須",
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: "正しいメールアドレスを入力してください",
                        trigger: ["blur", "change"]
                    }
                ],
                reemail: [
                    {
                        trigger: "blur",
                        validator: account_reemail
                    }
                ],
                rank: [{ required: true, message: "必須", trigger: "blur" }],
                favorability: [
                    {
                        trigger: ["blur", "change"],
                        validator: account_favorability
                    }
                ],
                gold: [
                    { trigger: ["blur", "change"], validator: account_gold }
                ],
                stone: [
                    { trigger: ["blur", "change"], validator: account_stone }
                ],
                createAccountTime: [
                    {
                        type: "date",
                        required: true,
                        message: "必須",
                        trigger: "change"
                    }
                ],
                birthday: [
                    { trigger: ["blur", "change"], validator: account_birthday }
                ],
                buyHistory: [
                    {
                        trigger: ["focus", "change"],
                        validator: account_buyHistory
                    }
                ],
                perChecked: [
                    {
                        trigger: "change",
                        validator: account_perChecked
                    }
                ]
            }
        };
    },
    created() {
        if (!this.$utils.isPC()) {
            this.labelPosition = "top";
        }
    },
    methods: {
        handlePreview(file) {
            console.log("handlePreview :", file);
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        handleExceed(files, fileList) {
            console.log(files, fileList);
            this.$message.warning(
                `当前限制选择 3 个文件，本次选择了 ${
                    files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        handleChange(files, fileList) {
            if (files.raw.type.indexOf("image") == -1) {
                this.$message.warning("画像をアップロードしてください");
                fileList.splice(
                    fileList.findIndex(item => item.uid == files.uid),
                    1
                );
            } else if (files.size / 1024 / 1024 > 4) {
                this.$message.warning("画像はひとつ4MB以内でお願いします");
                fileList.splice(
                    fileList.findIndex(item => item.uid == files.uid),
                    1
                );
            } else {
                this.fileList = fileList;
            }
        },
        accountConfirm() {
            this.$refs["account"].validate(valid => {
                if (!valid) {
                    return false;
                } else {
                    if(confirm('ご入力いたたいた内容で送信してよろしいでしょうか？')) {
                        this.confirm();
                    } else {
                        return false;
                    }
                }
            });
        },
        confirm() {
            let formData = new FormData();
            formData.set("name", this.accountForm.name);
            formData.set("friendID", this.accountForm.friendID);
            formData.set("email", this.accountForm.email);
            formData.set("rank", this.accountForm.rank);

            if (!this.accountForm.favorability.novalue) {
                let favorability =
                    this.accountForm.favorability.value1 +
                    " " +
                    this.accountForm.favorability.value2 +
                    " " +
                    this.accountForm.favorability.value3;
                formData.set("favorability", favorability);
            } else {
                formData.set("favorability", "不明");
            }

            formData.set(
                "gold",
                this.accountForm.gold.novalue
                    ? "不明"
                    : this.accountForm.gold.value
            );

            formData.set(
                "stone",
                this.accountForm.stone.novalue
                    ? "不明"
                    : this.accountForm.stone.value
            );
            formData.set(
                "createAccountTime",
                this.accountForm.createAccountTime
            );
            formData.set(
                "birthday",
                this.accountForm.birthday.novalue
                    ? "未設定"
                    : this.accountForm.birthday.value
            );

            for (let i = 0, len = this.upFileList.length; i < len; i++) {
                formData.append("fileList", this.upFileList[i]);
            }
            formData.set("content", this.accountForm.content);
            // 账号
            formData.set("type", "2");
            formData.set("title", "アカウントについて");

            this.$message({
                message:'送信が成功',
                duration: 10000
            });

            this.axios
                .post("/service/dismail", formData)
                .then(v => {
                    console.log(v);
                    if (v.data.retcode == 1) {
                        // 清空表单
                        /* this.fileList = [];
                        this.accountForm.name = "";
                        this.accountForm.friendID = "";
                        this.accountForm.email = "";
                        this.accountForm.reemail = "";
                        this.accountForm.rank = "";
                        this.accountForm.favorability.value1 = "";
                        this.accountForm.favorability.value2 = "";
                        this.accountForm.favorability.value3 = "";
                        this.accountForm.favorability.novalue = false;
                        this.accountForm.gold.value = "";
                        this.accountForm.gold.novalue = false;
                        this.accountForm.stone.value = "";
                        this.accountForm.stone.novalue = false;
                        this.accountForm.createAccountTime = "";
                        this.accountForm.birthday.value = "";
                        this.accountForm.birthday.novalue = false;
                        this.accountForm.buyHistory.novalue = true;
                        this.accountForm.content = "";
                        this.accountForm.perChecked = false; */
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        }
    },
    computed: {
        upFileList() {
            let _fileList = [];
            for (let i = 0, len = this.fileList.length; i < len; i++) {
                _fileList.push(this.fileList[i].raw);
            }
            return _fileList;
        }
    },
    watch: {
        fileList(val, oldval) {
            if (val.length) {
                this.accountForm.buyHistory.novalue = false;
            }
        },
        accountForm: {
            handler(val) {
                if (val.favorability.novalue) {
                    this.accountForm.favorability.value1 = "";
                    this.accountForm.favorability.value2 = "";
                    this.accountForm.favorability.value3 = "";
                }
                if (val.gold.novalue) {
                    this.accountForm.gold.value = "";
                }
                if (val.stone.novalue) {
                    this.accountForm.stone.value = "";
                }
                if (val.birthday.novalue) {
                    this.accountForm.birthday.value = "";
                }
            },
            deep: true
        }
    }
};
</script>


<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    color: #fff;

    & ::v-deep .el-button {
        background: transparent;
    }

    .title {
        width: 100%;
        background: #000;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px) pxTorem(10px) pxTorem(50px);
        .back {
            font-size: pxTorem(24px);
            cursor: pointer;
        }
    }
    .formWrap {
        width: 80%;
        margin: 0 auto;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px);

        @media screen and (max-width: 600px) {
            width: 100%;
        }

        & ::v-deep .el-form-item__label {
            color: #fff;
        }
        & ::v-deep .el-input__inner {
            color: #fff;
        }
        & ::v-deep .el-textarea__inner {
            background: transparent;
            color: #fff;
            font-family: $japaneseFontFamily;
            &::-webkit-scrollbar {
                width: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: #001238;
                border-radius: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #407cfd;
                border-radius: 8px;
            }
        }
        .tip {
            font-size: pxTorem(10px);
            color: #afafaf;
        }
        .checked {
            color: #ac7f00;
        }
        .el-upload__tip {
            color: #afafaf;
            line-height: 1.5;
        }
        & ::v-deep .el-upload-list__item {
            height: auto !important;
            border: 1px solid transparent;
        }
        & ::v-deep .el-upload-list__item:hover {
            background: transparent;
            border: 1px solid #fff;
        }
        & ::v-deep .el-upload-list__item-name {
            color: #fff;
        }
        & ::v-deep .el-icon-document {
            color: #fff;
        }
        & ::v-deep .el-icon-close {
            color: #fff;
        }
        .inputsBox {
            .el-input:not(:last-child) {
                margin-bottom: 10px;
            }
        }
    }
}
</style>